module.exports = __webpack_public_path__ + "static/media/moto-art-kielce.51ea3bde.png";